<script setup lang="ts">
import TrelloBoard from "src/components/trello-board/TrelloBoard.vue";
</script>

<template>
  <TrelloBoard />
</template>
